<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Car Booking History</h4>

            <div class="table-responsive">
              <table class="table table-bordered table-centered mb-0">
                <thead>
                <tr>
                  <th>Duration</th>
                  <th>PickUp Date</th>
                  <th>Return Date</th>
                  <th>Booking Cost</th>
                  <th>Status</th>
                  <th>Assigned Status</th>
                  <th>UnAssigned Car</th>
                  <th>Payment Option</th>
                  <th>Payment Status</th>
                </tr>
                </thead>
                <tbody v-if="isLoading">
                <tr v-for="(hist,i) in 4" :key="i">
                  <td>
                    <div class="lines shine"></div>
                  </td>
                  <td>
                    <div class="lines shine"></div>
                  </td>
                  <td>
                    <div class="lines shine"></div>
                  </td>
                  <td>
                    <div class="lines shine"></div>
                  </td>
                  <td>
                    <div class="lines shine"></div>
                  </td>
                  <td>
                    <div class="lines shine"></div>
                  </td>
                  <td>
                    <div class="lines shine"></div>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr v-for="(hist,i) in history" :key="i">
                  <td>{{ hist.duration_length }} {{ hist.duration }}(s)</td>
                  <td>{{ hist.pickup_date  | toHumanDate }} @ {{ hist.pickup_time }}</td>
                  <td>{{ hist.return_date | toHumanDate }} @ {{ hist.return_time }}</td>

                  <td>{{ hist.booking_cost | toCurrencyFormat }}</td>
                  <td>
                    <div class="badge badge-success" v-if="hist.status ==='booked'">{{ hist.status }}</div>
                    <div class="badge badge-info" v-if="hist.status ==='open'">{{ hist.status }}</div>
                  </td>
                  <td>
                    <span class="badge badge-outline-success" v-if="hist.assigned_status">True</span>
                    <span class="badge badge-outline-danger" v-else>False</span>
                  </td>
                  <td>
                    <span class="badge badge-outline-success" v-if="hist.unassigned_status">True</span>
                    <span class="badge badge-outline-danger" v-else>False</span>
                  </td>
                  <td>{{ hist.payment_option }}</td>
                  <td>
                    <span class="badge badge-outline-success"
                          v-if="hist.payment_status ==='succeeded'">{{ hist.payment_status }}</span>
                    <span class="badge badge-outline-info" v-else>{{ hist.payment_status ?? 'N/A' }}</span>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import vue2Dropzone from "vue2-dropzone";
import {confirm} from "@/utils/functions";
import {rentalsService} from "@/apis/rentals.service";


export default {
  name: 'CarDetail',
  head() {
    return {
      title: `${this.title} | RedCabs`,
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      history: [],
      isLoading: false
    }
  },
  computed: {},
  middleware: "router-auth",
  methods: {
    getCarBookingHistory(id) {
      this.isLoading = true;
      rentalsService.getCarBookingHistory(id).then((res) => {
        this.isLoading = false
        const {extra, message, status} = res;
        if (!status) {
          this.$store.dispatch('error', {message: message, showSwal: true});
          return;
        }
        this.history = extra;

      });
    },

  },
  async created() {
    const id = this.$route.params.id;
    if (!id) {
      await this.$router.push('/error/404')
      return;
    }
    this.getCarBookingHistory(id);
  }
};
</script>